<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Account</h3>

            <div class="search_bar mb-3">
                <b-button
                    class="btn-action"
                    size="sm"
                    variant="info"
                    :to="{
                        name: 'cms_account_add'
                    }"
                    v-if="
                        $store.state.user_obj &&
                            checkPermission(
                                $store.state.user_obj,
                                'Account',
                                'Account',
                                'Create',
                                true
                            )
                    "
                    >Add User</b-button
                >
            </div>

            <div class="search_bar mb-3">
                <b-row>
                    <b-col cols="2" class="pr-1">
                        <b-form-select
                            size="sm"
                            v-model="search_criteria.client_selected"
                            :options="client_options"
                        />
                    </b-col>

                    <b-col cols="3" class="pl-0 pr-1">
                        <b-form-input
                            id="input-small"
                            size="sm"
                            type="text"
                            placeholder="Name/Username/Phone"
                            v-model="search_criteria.keyword"
                        ></b-form-input>
                    </b-col>

                    <b-col>
                        <b-button
                            class="btn-action"
                            size="sm"
                            variant="info"
                            @click="onSearch"
                        >
                            <font-awesome-icon
                                class="mr-1"
                                icon="search"
                            />Search
                        </b-button>
                    </b-col>
                </b-row>
            </div>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />

            <b-table
                responsive
                small
                outlined
                striped
                hover
                sticky-header="500px"
                :items="items"
                :fields="fields"
            >
                <template v-slot:cell(client_name)="data">
                    {{ data.item.client_name || "-" }}
                </template>
                <template v-slot:cell(action)="data">
                    <b-button
                        class="btn-action"
                        size="sm"
                        variant="info"
                        :to="{
                            name: 'cms_account_edit',
                            params: { user_id: data.item.id }
                        }"
                        v-if="
                            $store.state.user_obj &&
                                checkPermission(
                                    $store.state.user_obj,
                                    'Account',
                                    'Account',
                                    'Edit',
                                    true
                                )
                        "
                        >Edit</b-button
                    >

                    <b-button
                        class="btn-action"
                        size="sm"
                        variant="danger"
                        @click="showModal_confirmDelete(data.item)"
                        v-if="
                            $store.state.user_obj &&
                                checkPermission(
                                    $store.state.user_obj,
                                    'Account',
                                    'Account',
                                    'Delete',
                                    true
                                )
                        "
                        >Delete</b-button
                    >
                </template>
            </b-table>

            <Pagination
                :totalRows="total_rows"
                :perPage="rows_per_page"
                :onPageChange="onPageChange"
                :pagingLimit="paging_limit"
                :currentPage="currentPage"
                :onPerPageChange="onPerPageChange"
            />

            <b-modal ref="modal_confirmDelete" centered hide-footer hide-header>
                <div class="d-block">
                    <b-row class="mb-3">
                        <b-col>Are you sure to delete this user?</b-col>
                    </b-row>
                </div>
                <div class="text-right">
                    <b-btn
                        class="mt-3"
                        variant="outline-danger"
                        @click="hideModal_confirmDelete"
                        >Cancel</b-btn
                    >
                    <b-btn
                        class="mt-3"
                        variant="outline-success"
                        @click="deleteUser()"
                        >Confirm</b-btn
                    >
                </div>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import global_function from "../mixins/global_function";

const fields = [
    {
        key: "id",
        label: "User ID"
    },
    {
        key: "client_name",
        label: "Client Name"
    },
    {
        key: "account_type",
        label: "Account Type"
    },
    {
        key: "username",
        label: "Username"
    },
    {
        key: "name",
        label: "Name"
    },
    {
        key: "phone",
        label: "Phone"
    },
    {
        key: "action",
        label: "Action"
    }
];

export default {
    name: "ProductMaster",
    mixins: [global_function],
    inject: [
        "API_HOST",
        "TABLE_LIMIT",
        "PAGING_LIMIT",
        "DEFAULT_ROWS_PER_PAGE"
    ],
    components: {
        Pagination
    },
    data() {
        return {
            upload_file: [],
            loader: false,
            items: [],
            fields: fields,
            currentPage: 1,
            //   table_offset: 0,
            total_rows: 0,
            rows_per_page: this.DEFAULT_ROWS_PER_PAGE,
            paging_limit: this.PAGING_LIMIT,
            search_criteria: {
                keyword: "",
                client_selected: null
            },
            client_options: [
                {
                    value: null,
                    text: "All Clients"
                }
            ]
        };
    },
    async created() {
        if (
            !this.checkPermission(
                this.$store.state.user_obj,
                "Account",
                "Account",
                "View",
                true
            )
        ) {
            this.$router.replace("/");
            return;
        }

        await this.getUsers();
        await this.getClients();
        this.initialized = true;
    },
    mounted() {
        if (
            !this.checkPermission(
                this.$store.state.user_obj,
                "Account",
                "Account",
                "View",
                true
            )
        ) {
            return;
        }

        this.loader = this.$loading.show({
            isFullPage: true,
            canCancel: false
        });
    },
    computed: {
        table_offset: function() {
            return (this.currentPage - 1) * this.rows_per_page;
        }
    },
    methods: {
        async getUsers() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_user_get.php",
                data: {
                    offset: this.table_offset,
                    limit: this.rows_per_page,
                    search_criteria: this.search_criteria,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                }
            });
            this.items = response.data.users;
            this.total_rows = parseInt(response.data.total_rows);
            this.loader.hide();
        },

        async getClients() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "client_profile_get.php",
                data: {}
            });

            this.client_options = [
                {
                    value: null,
                    text: "All Clients"
                }
            ];

            for (let i in response.data.clients) {
                let client_obj = {
                    value: response.data.clients[i].id,
                    text: response.data.clients[i].client_name
                };

                this.client_options.push(client_obj);
            }
        },

        onSearch() {
            this.getUsers();
        },

        onPageChange(page_to_change) {
            this.currentPage = page_to_change;
            this.getUsers();
        },

        onPerPageChange(_perPage) {
            this.currentPage = 1;
            this.rows_per_page = _perPage;
            this.getUsers();
        },

        showModal_confirmDelete(item) {
            this.$refs.modal_confirmDelete.item = item;
            this.$refs.modal_confirmDelete.show();
        },

        hideModal_confirmDelete() {
            this.$refs.modal_confirmDelete.hide();
        },

        async deleteUser() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "cms_user_delete.php",
                data: {
                    cms_user_id: this.$refs.modal_confirmDelete.item.id,
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.getUsers();
            this.hideModal_confirmDelete();
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/CmsAccount.vue